<template>
    <div>
      <div class="modal fade" id="login" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true" 
              data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content" style="width: 500px;height:77vh" :style="'background:'+skin.main_color_1">
                  <div class="modal-header py-2" style="border-bottom: 1px solid #ffffff0d;">
                      <div class="modal-header-container" style="display: flex;justify-content: space-between;width: 100%;">
                          <div style="height: 54px; width: 88px;display: flex;align-items: center;justify-content: center;">
                              <img :src="skin.header_mobil.logo" alt="" style="max-width: 100%; height: auto; width: auto; max-height: 50px;">
                          </div>
                          <div style="display: flex;align-items: center;">
                              <button class="register" :style="'background:'+skin.main_active_1">REGISTRARSE</button>
                              <button id="closeLogin" style="background:transparent;" type="button" class="btn-close m-1" data-bs-dismiss="modal" aria-label="Close">
                                  <i style="font-size: 24px;text-align: center;color: #ffffff99;" class="fas fa-times"></i>
                              </button>
                          </div>
                      </div>
                  </div>
                  <div class="modal-body p-2" style="">
                      <div class="py-2">
                          <span class="pregunta-cuenta">¿Ya tiene una cuenta?</span>
                      </div>
                      <div class="py-2">
                          <span style="font-size: 18px;color: #FFFFFF;">INICIE SESIÓN, LO ESTABAMOS ESPERANDO</span>
                      </div>
                      <div class="text-center">
                          <form @submit.prevent="login()">
                              <div class="mb-3">
                                  <input v-model="username" style="height: 52px;
                                                                   border: 0px solid #18242f; 
                                                                   color: #ffffffe6;
                                                                   background-color: #ffffff26;" id="username" type="text" class="form-control shadow-none" :placeholder="translate('enter_username')" aria-label="Username" aria-describedby="user-1" required>
                              </div>
                              <div v-if="!resetPassword" :class="skin.reset_password?'mb-0':'mb-3'">
                                  <input v-model="password" style="height: 52px;
                                                                   border: 0px solid #18242f; 
                                                                   color: #ffffffe6;
                                                                   background-color: #ffffff26;" id="password" type="password" class="form-control shadow-none" :placeholder="translate('enter_password')" aria-label="Password" aria-describedby="password-1" required>
                              </div>
                              <div v-if="skin.reset_password" class="text-end mb-3">
                                  <span @click="reset_password()" style="text-decoration: underline;cursor:pointer;">{{ translate("forgot_password") }}</span>
                              </div>
                              <button id="submit_btn" type="submit" class="p-2 text-center mb-2" style="width: 100%;color: white;border: none;outline: none;background: #386890;font-size: 12px;border-radius: 4px;" :disabled="login_inProcess">
                                  {{translate("log_in")}}
                              </button>
                          </form>
                          <div v-if="status.message!=''" :class="'alert alert-'+status.type" role="alert">{{ status.message }}</div>
                      </div>
                      <div class="mt-4" style="display: flex;align-items: center;justify-content: center;">
                              <span class="has-olvidado-password">¿HA OLVIDADO SU CONTRASEÑA?</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
      name:"login",
      props:['skin','translation','language'],
      data(){
          return {
              username:"",
              password:"",
              resetPassword:false,
              status:{
                  message:"",
                  type:""
              },
              login_inProcess:false
          }
      },
      computed:{
      },
      methods:{
          async login(){
              this.login_inProcess = true;
              if(this.resetPassword){
                  if(this.username!=""){
                      let reset = await axios.post(this.$store.getters["getDomain"]+"/swarm/remote/forgot_password",{
                          "email":this.username
                      })
                      if(reset.data.success){
                          this.status.message=reset.data.message;
                          this.status.type="success";
                      }
                      else{
                          this.status.message=reset.data.message;
                          this.status.type="danger";
                      }
                      this.resetPassword = false;
                  }
                  else{
                      this.status.message=this.translate("input_email");
                      this.status.type="danger"; 
                  }
                  this.login_inProcess = false;
              }
              else{
                  let data = await this.$store.dispatch('login',{username:this.username,password:this.password});
                  if(data=="success"){
                      document.getElementById('closeLogin').click();
                      this.$root.$emit('forceRender');
                      this.login_inProcess = false;
                  }
                  else{
                      this.status.message=data;
                      this.status.type="danger";
                      this.login_inProcess = false;
                  }
              }
              
          },
          reset_password(){
              this.resetPassword = true;
              this.login();
          },
          translate(text) {
              if(text){
                  if (this.$props.translation[text]) {
                      return this.$props.translation[text][this.$props.language];
                  }
                  else{
                      var new_text_serched = text.replace(/ /g, "_");
                      if (this.$props.translation[new_text_serched]) {
                          return this.$props.translation[new_text_serched][this.$props.language];
                      }
                  }
                  return text;
              }
          },
      }
  }
  </script>
  
  <style>
  
  .register {
          padding: 0 8px;
          color: rgba(0, 0, 0, 1);
          margin-inline-start: 10px;
          margin-inline-end: 10px;
          height: 28px;
          border-radius: 4px;
          /* background-color: #fff200; */
          border: none;
          outline: none;
          font-size: 12px;
      }
      /* .register:hover {
          cursor: pointer;
          background: #ccc100 !important;
      } */
  .pregunta-cuenta {
      color: #FFFFFF80;
      font-size: 14px;
  }
  
  .has-olvidado-password {
      font-size: 14px;
      color: #ffffffb3;
  }
  
  .has-olvidado-password:hover {
          color: #ffffffe6;
          cursor: pointer
      }
  </style>